(function () {
  window.RB = window.RB || {};

  const RUNE_GLYPHS = {
    fury: ["F", "fury"], calm: ["C", "calm"], mind: ["M", "mind"],
    body: ["B", "body"], chaos: ["X", "chaos"], order: ["O", "order"], rainbow: ["◆", "rainbow"],
  };

  function normalizeIcons(text) {
    return String(text || "").replace(/\[(energy_\d+|rune_\w+|exhaust|might)\]/gi, function (m, tok) {
      return ":rb_" + tok.toLowerCase() + ":";
    });
  }

  function plain(text) {
    let out = normalizeIcons(text);
    out = out.replace(/:rb_energy_(\d+):/g, "$1⚡");
    out = out.replace(/:rb_exhaust:/g, "⟳");
    out = out.replace(/:rb_might:/g, "M");
    out = out.replace(/:rb_rune_(\w+):/g, function (m, d) { return "[" + (RUNE_GLYPHS[d] || [d])[0] + "]"; });
    return out;
  }

  function stripReminder(t) {
    return (t || "").replace(/\(.*?\)/g, "").replace(/\s+/g, " ").trim();
  }

  function cardText(card) {
    if (!card) return "";
    if (card.manual && card.manual.length) return plain(card.manual.join(" ")).replace(/\s+/g, " ").trim();
    return "";
  }

  window.RB.Text = {
    RUNE_GLYPHS: RUNE_GLYPHS,
    normalizeIcons: normalizeIcons,
    plain: plain,
    stripReminder: stripReminder,
    cardText: cardText,
  };
})();
